// extracted by mini-css-extract-plugin
export default {"container":"A0-z"};